export const MenuItems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-Links",
    toName: "Home",
    isExternal: true
  },
  {
    title: "About Us",
    url: "/aboutUs",
    cName: "nav-Links",
    toName: "about_us",
    isExternal: true,
  },
  {
    title: "VYN",
    url: "/vyn",
    cName: "nav-Links",
    toName: "vyn_page",
    isExternal: true,
  },
  
  {
    title: "UKG Services",
    url: "/services",
    cName: "nav-Links",
    toName: "ukg_services",
    isExternal: true,
  },
  {
    title: "Blogs",
    url: "/blogUser",
    cName: "nav-Links",
    toName: "Blogs",
    isExternal: true,
  },
  // {
  //   title: "Resources",
  //   url: "/",
  //   cName: "nav-Links",
  //   toName: "WhoWeAre",
  // },
  // {
  //   title: "Why Us",
  //   url: "/",
  //   cName: "nav-Links",
  //   toName: "WhyUs",
  // },
  // {
  //   title: "Careers",
  //   url: "/",
  //   cName: "nav-Links",
  //   toName: "Solutions",
  // },
  // {
  //   title: "Contact Us",
  //   url: "/",
  //   cName: "nav-Links",
  //   toName: "ContactUs",
  //   // isExternal: true
  // },
  {
    title: "Contact Us",
    url: "#", // Keep URL as "#" or empty if not needed
    cName: "nav-Links",
    toName: "ContactUs",
    isModal: true, // New flag to indicate modal behavior
  },
];
